import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-lock-in-modal',
  templateUrl: './lock-in-modal.component.html',
  styleUrls: ['./lock-in-modal.component.scss']
})
export class LockInModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LockInModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { locked: boolean }) {
  }

  ngOnInit(): void {
  }

}
